// client/src/components/catalogoModelo/ResultadoImportacaoTable.js
import React from 'react';
import { CheckCircle2, Copy, XCircle as XCircleIcon } from 'lucide-react';

const STATUS_LABEL = {
    criado: { label: 'Criado', className: 'badge-green', icon: CheckCircle2 },
    duplicado: { label: 'Duplicado', className: 'badge-yellow', icon: Copy },
    ja_existe: { label: 'Já existe', className: 'badge-yellow', icon: Copy },
    erro: { label: 'Erro', className: 'badge-red', icon: XCircleIcon }
};

// ✅ Tabela de resultado por item compartilhada entre o import CSV da
// Matriz (ImportarCsvCatalogoModeloForm.js, status: criado/duplicado/erro,
// com coluna extra "Linha") e o import em massa por categoria da Conta
// (ImportarCategoriaModal.js, status: criado/ja_existe/erro, sem coluna extra).
const ResultadoImportacaoTable = ({ resultados = [], extraColumn = null }) => (
    <div className="table-wrapper">
        <table className="styled-table">
            <thead>
                <tr>
                    {extraColumn && <th>{extraColumn.label}</th>}
                    <th>Nome</th>
                    <th>Status</th>
                    <th>Detalhe</th>
                </tr>
            </thead>
            <tbody>
                {resultados.map((r, idx) => {
                    const info = STATUS_LABEL[r.status] || { label: r.status, className: 'badge-gray', icon: null };
                    const Icon = info.icon;
                    return (
                        <tr key={r.catalogoModeloItemId || `${r.linha || idx}-${r.nome}`}>
                            {extraColumn && <td>{r[extraColumn.key]}</td>}
                            <td>{r.nome || '—'}</td>
                            <td>
                                <span className={`badge ${info.className}`}>
                                    {Icon && <Icon size={14} className="icon" />}
                                    {info.label}
                                </span>
                            </td>
                            <td>{r.erro || '—'}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
);

export default ResultadoImportacaoTable;
